import { Box, Paragraph, Text } from '@zillow/constellation-10';

import type { RenterPaymentMethodInterface } from '@renter-hub/models/Types';

interface Props {
  paymentMethodToDelete: RenterPaymentMethodInterface;
}

export const DeletePaymentMethodConfirmation = ({ paymentMethodToDelete }: Props) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Paragraph>{`This will permanently remove your account ending in ${paymentMethodToDelete.accountLast4}.`}</Paragraph>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text textStyle="body-bold">{paymentMethodToDelete.displayName}</Text>
        <Text>{`(...${paymentMethodToDelete.accountLast4})`}</Text>
      </Box>
    </Box>
  );
};
